export interface ReportPeriod {
  year: number;
  month: number;
}

/** Recipes serializes order dates in a mixture of timestamps and locale strings. */
export function dateInReportPeriod(value: unknown, period: ReportPeriod): boolean {
  const date = parseRecipesDate(value);
  return !!date && date.getUTCFullYear() === period.year && date.getUTCMonth() + 1 === period.month;
}

export function parseRecipesDate(value: unknown): Date | null {
  if (value == null || value === "") return null;

  if (value instanceof Date && !Number.isNaN(value.getTime())) return value;

  if (typeof value === "number" || (typeof value === "string" && /^\d{10,13}$/.test(value.trim()))) {
    const raw = Number(value);
    const date = new Date(raw < 10_000_000_000 ? raw * 1000 : raw);
    return Number.isNaN(date.getTime()) ? null : date;
  }

  if (typeof value !== "string") return null;
  const text = value.trim();
  const match = text.match(/^(\d{1,2})[\/-](\d{1,2})[\/-](\d{2,4})/);
  if (match) {
    const day = Number(match[1]);
    const month = Number(match[2]);
    const year = Number(match[3].length === 2 ? `20${match[3]}` : match[3]);
    const date = new Date(Date.UTC(year, month - 1, day));
    return date.getUTCFullYear() === year && date.getUTCMonth() === month - 1 && date.getUTCDate() === day
      ? date
      : null;
  }

  const parsed = new Date(text);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function isReceivedOrderStatus(status: unknown): boolean {
  // ProveidorsComandesType.Recived is the value rendered as the green check in Recipes.
  return Number(status) === 2;
}

export function orderOperationalDate(order: Record<string, unknown>): unknown {
  return order.dateSent ?? order.dateGeneratedTimestamp ?? order.dateGeneratedAt ?? order.dateGenerated ?? order.dateGeneratedFlat;
}
